import { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Navstrip from "./components/Navstrip";

export default function RootLayout() {
  const navigate = useNavigate();
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    const syncLogout = (e) => {
      if ((e.key === "user" && e.newValue === null) || e.key === "logout") {
        setIsLoggedOut(true); // trigger React update
      }
    };

    window.addEventListener("storage", syncLogout);
    return () => window.removeEventListener("storage", syncLogout);
  }, []);

  // React will run this redirect during render
  useEffect(() => {
    if (isLoggedOut) {
      localStorage.clear();
      navigate("/", { replace: true });
    }
  }, [isLoggedOut, navigate]);

  
  return (
    <div>
      {/* Your Navbar */}
      <Navbar />
      <Navstrip />
      <Outlet />
      <Footer />
    </div>
  );
  
}
